import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PoolCurrency} from './../../types/PoolCurrency';

@Injectable()
export class ExchangeService {
    constructor(private http: HttpClient) {}

    public getBalances(): Observable<any> {
        return this.http.get<any>('/admin/exchange/balances');
    }

    public getMarkets(): Observable<any> {
        return this.http.get<any>('/admin/exchange/markets');
    }

    public getTicker(): Observable<any> {
        return this.http.get<any>('/admin/exchange/ticker');
    }

    public getCurrencies(): Observable<any> {
        return this.http.get<any>('/admin/exchange/currencies');
    }

    public getRate(from: string, to: string): Observable<any> {
        return this.http.get<any>(`/admin/exchange/rate/${from}/${to}`);
    }

    public getPairs(): Observable<any> {
        return this.http.get<any>(`/admin/exchange/pairs`);
    }

    public updatePair(data: any): Observable<any> {
        return this.http.put<any>(`/admin/exchange/pairs`, data);
    }

    public getOrders(): Observable<any> {
        return this.http.get<any>(`/admin/exchange/orders`);
    }

    public getTokens(): Observable<PoolCurrency[]> {
        return this.http.get<any[]>('/admin/exchange/pool/currency/list');
    }

    public getToken(code: string): Observable<PoolCurrency> {
        return this.http.get<any>(`/admin/exchange/pool/currency/${code}`);
    }

    public setTokenValue(tokenData: { code: string; value: number }): Observable<any> {
        return this.http.post('/admin/exchange/pool/currency/value', tokenData);
    }
}
